<template>
  <v-app-bar
    :height="pcOnly ? 130 : 100"
    class="navbar pa-0"
    :flat="!light"
    fixed
    :transparent="true"
  >
    <v-row class="mt-2">
      <v-col md-6>
        <logo :light="false" mb-4 :width="pcOnly ? (window.width >= 1200 ? 300 : 200) : 125" />
          <v-spacer />
      </v-col>
      <v-col md-6>
        <div class="d-flex align-center mt-6 mb-4 mr-4">
          <v-slide-x-reverse-transition appear class="d-flex align-center">
            <div class="d-flex align-right">
              <div v-if="pcOnly && window.width >= 1200" class="d-flex align-center">
                <v-btn
                  :color="activeSection === link.name ? 'primary' : 'black'"
                  v-for="link in links"
                  :key="link.name"
                  :text="activeSection !== link.name"
                  class="ms-2 font-weight: bolder"
                  @click="navigateToLink(link.ref)"
                  x-large
                  >{{ $t(`links.${link.name}`) }}</v-btn
                >
              </div>
              <!-- <div class="d-flex align-center ms-8">
                <locale-button :large="pcOnly" />
              </div> -->
            </div>
          </v-slide-x-reverse-transition>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
// import LocaleButton from "../custom/locale-button";
import Logo from "./logo";

import GlobalComputed from "@/helpers/global-computed";
import GlobalMethods from "@/helpers/global-methods";
import links from "@/helpers/links";

export default {
  name: "navbar",
  components: {
    Logo,
    // LocaleButton,
  },
  props: {
    lightTheme: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  data() {
    return {
      scrolled: false,
      links,
      window: {
        width: 0,
        height: 0,
      },
    };
  },
  computed: {
    light() {
      return this.lightTheme && this.scrolled;
    },
    activeSection() {
      return this.$store.state.activeSection;
    },
    ...GlobalComputed,
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
    },

    ...GlobalMethods,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
};
</script>

<style lang="scss">
.v-application .navbar {
  position: absolute;
  height: 90px;
  left: 0px;
  top: 0px;
  background-size: 100% 100%; /* <------ */
  background-position: 10% 0%;
  backdrop-filter: blur(25px);

  background-color: white !important;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0px;
  &,
  .v-toolbar__content {
    transition: height 0.2s ease-out, background-color 0.1s linear !important;
  }
  &.soft-shadow {
    box-shadow: 0 0 transparent, 0 0 transparent,
      0 5px 5px -4px rgba(0, 0, 0, 0.1) !important;
  }
  &.blank {
    &,
    .v-toolbar__content {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
    }
  }
  .v-btn {
    font-weight: normal !important;
    text-transform: capitalize;
    letter-spacing: 1.1px;
    border-radius: 3px;
  }
}
</style>
